import * as React from 'react';
/**
 *
 * Original name: zip
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=11091%3A11
 *
 */
export const ZipSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M107 13H13v82.013C13 101.633 18.367 107 24.987 107h70.026c6.62 0 11.987-5.367 11.987-11.987V13ZM19 95.013V19h32v6h9v6h-9v6h9v6h-9v6h9v6h-9v23.003c0 6.224 2.776 9 9 9s9-2.776 9-9V61h-9v-6h9v-6h-9v-6h9v-6h-9v-6h9v-6h-9v-6h41v76.013A5.987 5.987 0 0 1 95.013 101H24.987A5.987 5.987 0 0 1 19 95.013Zm42.667-14.516a3 3 0 1 1-3.334-4.99 3 3 0 0 1 3.334 4.99Z", fill: "currentColor" })));
